import { App } from "./components/App"
import "./styles/scrollbar.css"

export default App
